module.exports = __webpack_public_path__ + "image/green_icon_shubiao.png";